import {symbolTypes} from './symbols'

export class Glyph {
  constructor(sizeModifier, glyphClass = 'glyph') {
    this.sizeChoices = [1, 1.25, 1.5]
    this.rotation = 0
    this.rotationSpeed = Math.random() * 3
    this.size = this.getSize(sizeModifier)
    this.type = this.getType()
    this.class = this.getClass(glyphClass)
  }
  getClass(glyphClass) {
    this.styleClass = glyphClass
    return `${glyphClass} ${this.type}`
  }
  getSize(sizeModifier) {
    const sizeChoice = this.chooseRandomItem(this.sizeChoices)
    return sizeChoice * sizeModifier
  }
  getType() {
    return this.chooseRandomItem(symbolTypes)
  }
  rotate() {
    this.rotation += this.rotationSpeed
    return this.rotation
  }
  chooseRandomItem(array) {
    return array[Math.floor(Math.random() * array.length)]
  }
}

export class FocusedGlyph extends Glyph {
  constructor(sizeModifier, glyphClass, focusId) {
    super(sizeModifier, glyphClass)
    this.focusId = focusId
  }
}

export class ClassedGlyph extends Glyph {
  constructor(sizeModifier, classPopulationWieghts) {
    super(sizeModifier)
    const populationConfig = classPopulationWieghts.slice(0)
    populationConfig.sort((a, b) => a.weight - b.weight)
    this.class = this.getClass(this.chooseClass(populationConfig))
  }
  chooseClass(populationConfig) {
    const chance = Math.random()
    const weightLength = populationConfig.length - 1
    let index = 0

    for (; index < weightLength; index++) {
      if (chance <= populationConfig[index].weight) {
        return populationConfig[index].class
      }
    }

    return populationConfig[weightLength].class
  }
}

export class ClassedFocusedGlyph extends ClassedGlyph {
  constructor(sizeModifier, classPopulationWieghts) {
    super(sizeModifier, classPopulationWieghts)
    this.focusId = this.getFocusId(classPopulationWieghts)
  }
  getFocusId(classPopulationWieghts) {
    const classCategories = classPopulationWieghts.map(item => item.class)
    return classCategories.indexOf(this.styleClass)
  }
}

export class HexagonGlyph extends Glyph {
  getType() {
    return symbolTypes[symbolTypes.indexOf('hexagon')]
  }
}

export class YellowHexagonGlyph extends HexagonGlyph {
  constructor(sizeModifier) {
    super(sizeModifier, 'glyph glyph--yellow')
  }
}
